import { render, staticRenderFns } from "./QC.vue?vue&type=template&id=2fb177bd&scoped=true"
import script from "./QC.vue?vue&type=script&lang=js"
export * from "./QC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb177bd",
  null
  
)

export default component.exports